import React, { lazy } from "react";

const Login = lazy(() => import("../pages/common/Login"));

export const guestRoutes = [
  {
    path: "/login",
    element: <Login />,
    name: "Login",
  },
];
